module.exports = __webpack_public_path__ + "fded1a086456b6fc2459ed841721122d.svg";